export default __webpack_public_path__ + "static/media/logo.8fd63c2d.svg";